

const initialState = {
    locations: [],
    locationTypes: [],
    locationDrop:[],
    locationsDropDown:[],
    countries:[],
    states:[]
};


function LocationReducer(state = initialState, action) {


    if (action.type === "LOCATIONS_LIST") {
        var locationDetails = {
            ...state,
            locations: action.payload
        };
        return locationDetails;
    }

    if (action.type === "LOCATIONS_LIST_DROPDOWN") {
        var locationDetails = {
            ...state,
            locationDrop: action.payload
        };
        return locationDetails;
    }

    if (action.type === "LOCATIONS_DROPDOWN") {
        var locationDetails = {
            ...state,
            locationsDropDown: action.payload
        };
        return locationDetails;
    }
    
    if (action.type === "LOCATION_TYPE_DROPDOWN_LIST") {
        var locationDetails = {
            ...state,
            locationTypes: action.payload
        };
        return locationDetails;
    }

    if (action.type === "COUNTRIES_DROPDOWN") {
        var locationDetails = {
            ...state,
            countries: action.payload
        };
        return locationDetails;
    }


    return state;
}

export default LocationReducer;














